var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_406_8",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0.5V15.5H0.5V0.5H15.5Z",
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_406_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 2.66602H2.66684C2.31321 2.66602 1.97408 2.80649 1.72403 3.05654C1.47398 3.30659 1.3335 3.64573 1.3335 3.99935V13.3327C1.3335 13.6863 1.47398 14.0254 1.72403 14.2755C1.97408 14.5255 2.31321 14.666 2.66684 14.666H12.0002C12.3538 14.666 12.6929 14.5255 12.943 14.2755C13.193 14.0254 13.3335 13.6863 13.3335 13.3327V8.66602",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3335 1.66617C12.5987 1.40095 12.9584 1.25195 13.3335 1.25195C13.7085 1.25195 14.0683 1.40095 14.3335 1.66617C14.5987 1.93138 14.7477 2.29109 14.7477 2.66617C14.7477 3.04124 14.5987 3.40095 14.3335 3.66617L8.00017 9.99954L5.3335 10.6661L6.00017 7.9995L12.3335 1.66617Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkEditIcon);
export default __webpack_public_path__ + "static/media/dark-edit-icon.9df40c404084e0dbfdbf88959867e458.svg";
export { ForwardRef as ReactComponent };